import { render, staticRenderFns } from "./CollapseCard.vue?vue&type=template&id=789306ce&scoped=true"
import script from "./CollapseCard.vue?vue&type=script&lang=ts"
export * from "./CollapseCard.vue?vue&type=script&lang=ts"
import style0 from "./CollapseCard.vue?vue&type=style&index=0&id=789306ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789306ce",
  null
  
)

export default component.exports